import { render, staticRenderFns } from "./ItemCardStockState.vue?vue&type=template&id=63f2a926&scoped=true"
import script from "./ItemCardStockState.vue?vue&type=script&lang=ts"
export * from "./ItemCardStockState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2a926",
  null
  
)

export default component.exports